import { StoreError } from '~/common/model'

export enum ServiceTypes {
  VOICE = 'VOICE',
  VOICE_MAIL = 'VOICE_MAIL',
  AVAILABILITY_NOTIFICATION = 'AVAILABILITY_NOTIFICATION',
  NUMBER_IDENTIFICATION = 'NUMBER_IDENTIFICATION',
  CALL_FORWARDING = 'CALL_FORWARDING',
  LANGUAGE = 'LANGUAGE',
  CALLS_NOTIFICATION = 'CALLS_NOTIFICATION',
  INCOMING_CALLS_BLOCK = 'INCOMING_CALLS_BLOCK',
  OUTGOING_CALLS_BLOCK = 'OUTGOING_CALLS_BLOCK',
  OUTGOING_SMS = 'OUTGOING_SMS',
  INTERNET_3G = 'INTERNET_3G',
  ROAMING = 'ROAMING',
  INCOMING_SMS = 'INCOMING_SMS',
  MMS = 'MMS',
  INTERNET_4G = 'INTERNET_4G',
  PREMIUM_SERVICES = 'PREMIUM_SERVICES',
  BARRINGS = 'BARRINGS',
  INTERNET_5G = 'INTERNET_5G',
  INTERNATIONAL_CALLS_BLOCK = 'INTERNATIONAL_CALLS_BLOCK',
  INTERNET = 'INTERNET',
  SPEED = 'SPEED',
  AWAITING_CALLS = 'AWAITING_CALLS',
  THREE_PERSON_CALLS = 'THREE_PERSON_CALLS',
  BLOCK_SPECIAL_TARIFF_NUMBERS = 'BLOCK_SPECIAL_TARIFF_NUMBERS',
  DO_NOT_DISTURB = 'DO_NOT_DISTURB',
  FAX_TO_MAIL = 'FAX_TO_MAIL',
  OFFICE_365 = 'OFFICE_365',
  FIXED_IP = 'FIXED_IP',
  BLOCKS = 'BLOCKS',
  AVAILABLE_NETWORKS = 'AVAILABLE_NETWORKS',
}

export interface Service {
  id: ServiceTypes
  name: string
  active: boolean
}
export interface ServiceData {
  total: number
  items: Service[]
}

export interface ResponseService {
  service: ServiceData
  subscriptionId: string
}

export interface FetchServiceRequest {
  subscriptionId: string
  brand: string
  sub: string
}

export interface ErrorResponseService {
  error: StoreError
  subscriptionId: string
}
